export default "__VITE_ASSET__RkmRqRKN__"